export default "__VITE_PUBLIC_ASSET__e9718d1d__"